<template>
  <div>
    <NavigationBar
      titel="Qualifikationsgruppe bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        v-model="helpers.formIsValid"
        ref="form"
        @submit.prevent="updateItem"
      >
        <skill-group-editor
          v-model="skillGroup"
          mode="edit"
        ></skill-group-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { UPDATE_SKILL_GROUP } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import SkillGroupEditor from "@/components/member-management/skills/SkillGroupEditor.vue";

export default {
  name: "my-organization-skills-skill-edit",
  components: {
    NavigationBar,
    SkillGroupEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],

      helpers: {
        formIsValid: false,
      },
      skillGroup: null,
      skillsQuery: [],
    };
  },
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("skills")
        .where("group.id", "==", this.$route.params.itemId)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.skillsQuery.push(doc.data());
          });
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });

      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("skillGroups")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.skillGroup = doc.data();
            this.skillGroup.skills = this.skillsQuery;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    updateItem() {
      this.$refs.form.validate();
      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MEMBER_MANAGEMENT}${UPDATE_SKILL_GROUP}`, {
          organizationId: this.$route.params.organizationId,
          itemId: this.$route.params.itemId,

          title: this.skillGroup.title,
          isHiddenInProfile: this.skillGroup.isHiddenInProfile,
          skillsAreEqual: this.skillGroup.skillsAreEqual,
          sortKey: this.skillGroup.sortKey,
          color: this.skillGroup.color,
          icon: this.skillGroup.icon,
        });
      } else {
        alert("Prüfen Deine Eingabe und versuchen es erneut.");
      }
    },
  },
};
</script>
